<div *ngIf='(vm$ | async) as vm'>
    <app-page-header [vm]="vm" title='Rate Issues' [canGoBack]="true" [canRefresh]="true"
        (refreshClick)="refreshPage()" [notify]="notifyObj"></app-page-header>

    <!-- body -->
    <div class="row center">

        <!-- stat panel -->
        <div class="col-md-12 pt-3" *ngIf="vm.statPanelVm as svm">
            <mdb-card narrower="true" cascade="true">
                <app-card-header [title]="svm.data.title" [headingSize]="3"></app-card-header>
                <mdb-card-body cascade="true">
                    <div class="row">
                        <div class="col-md-3 pb-3" *ngFor="let s of svm.data.stats">
                            <h5>
                                <strong>{{s.statName}}:</strong>
                                <small class="text-muted pl-1">{{s.intValue}}</small>
                            </h5>
                        </div>
                    </div>
                </mdb-card-body>
            </mdb-card>
        </div>
    </div>

    <div class="row">
        <!-- affiliate rates-->
        <div class="col-md-6 pt-3" *ngIf="vm.affiliateRatePanelVm as arvm">
            <app-data-table-card [vm]="arvm" [includeAction]="true" (actionFunc)="sendToIT($event)" (actionMethod)="doAction($event)" [keyColumn]="0"></app-data-table-card>
        </div>

        <!-- corporation rates-->
        <div class="col-md-6 pt-3" *ngIf="vm.corporationRatePanelVm as crvm">
            <app-data-table-card [vm]="crvm" [includeAction]="true" (actionFunc)="sendToIT($event)" (actionMethod)="doAction($event)" [keyColumn]="0"></app-data-table-card>
        </div>
    </div>

    <div class="row">
        <!-- affiliate pricing zones-->
        <div class="col-md-6 pt-3" *ngIf="vm.affiliatePricingZonesPanelVm as apzvm">
            <app-data-table-card [vm]="apzvm" [includeAction]="true" (actionFunc)="sendToIT($event)" (actionMethod)="doAction($event)" [keyColumn]="0"></app-data-table-card>
        </div>

        <!-- corporation pricing zones-->
        <div class="col-md-6 pt-3" *ngIf="vm.corporationPricingZonesPanelVm as cpzvm">
            <app-data-table-card [vm]="cpzvm" [includeAction]="true" (actionFunc)="sendToIT($event)" (actionMethod)="doAction($event)" [keyColumn]="0"></app-data-table-card>
        </div>
    </div>
</div>